export default {
  radius: 'required|integer|between:0,99999999999',
  damage_type_id: 'required'
}
